import styled from "styled-components";
import { breakpoints } from "@tvg/design-system";

export const Container = styled.div<{ isFloating: boolean }>`
  display: flex;
  width: 100%;
  background-color: ${({ theme }) =>
    theme.colorTokens.background.negativeSubtle};
  border: solid
    ${({ theme }) => theme.colorTokens.component.notification.negative.border};
  border-bottom: none;
  border-radius: ${({ isFloating }) =>
    isFloating
      ? "var(--fd-radii-border-radius-020) var(--fd-radii-border-radius-020) 0 0"
      : 0};
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: var(--fd-space-space-3);
  width: 100%;
  justify-content: center;

  @media screen and ${breakpoints.desktop.max.sm} {
    align-items: flex-start;
    justify-content: flex-start;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  @media screen and ${breakpoints.desktop.max.sm} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  padding-right: var(--fd-space-space-3);
`;

export const Title = styled.div<{ isExpanded: boolean }>`
  color: ${({ theme }) =>
    theme.colorTokens.component.notification.negative.content};
  font-family: ${({ theme }) => theme.fonts.bold};
  font-size: 14px;

  @media screen and ${breakpoints.desktop.max.sm} {
    font-family: ${({ theme, isExpanded }) =>
      isExpanded ? theme.fonts.bold : theme.fonts.regular};
  }
`;

export const Button = styled.button`
  background-color: transparent;
  color: ${({ theme }) =>
    theme.colorTokens.component.notification.negative.content};
  font-family: ${({ theme }) => theme.fonts.bold};
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 120px;
  padding-right: var(--fd-space-space-3);
`;
